import { Alert, Box, Button, Container, Paper, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

interface Props {
  onNavigateDashboard: () => void;
}

export default function ApprovedStatusPage({ onNavigateDashboard }: Props) {
  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
      <Container maxWidth="sm" sx={{ pt: 8 }}>
        <Paper sx={{ p: 4, textAlign: "center", borderRadius: 3 }}>
          <CheckCircleOutlineIcon
            sx={{ fontSize: 80, color: "success.main", mb: 2 }}
          />
          <Typography variant="h4" fontWeight={700} mb={2}>
            가입이 승인되었습니다!
          </Typography>
          <Typography variant="body1" color="text.secondary" mb={3}>
            Silver Connect에 오신 것을 환영합니다.
            <br />
            지금 바로 대시보드에서 새로운 인연을 만나보세요.
          </Typography>
          <Alert severity="info" sx={{ mb: 3, textAlign: "left" }}>
            프로필이 승인되어 모든 서비스를 이용하실 수 있습니다. 매주 새로운
            큐피트 카드가 발급됩니다.
          </Alert>
          <Button
            variant="contained"
            fullWidth
            onClick={onNavigateDashboard}
            sx={{
              borderRadius: 2,
              bgcolor: "#0D1F3C",
              "&:hover": { bgcolor: "#0A1830" },
              fontWeight: 700,
              fontSize: "1rem",
              minHeight: 52,
            }}
          >
            대시보드로 이동
          </Button>
        </Paper>
      </Container>
    </Box>
  );
}
